/*---------------------------------------------------------------------------------------------
 *  Copyright (c) i-Bridge Systems Philippines Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
import {
  Box,
  Typography,
  List,
  ListItem,
  Divider,
  Grid,
  Tooltip,
} from '@mui/material';
import { OutlinedButton, ChangePassModal, TwoFaModal } from '../index';
import { useEffect, useState } from 'react';
import { apiUrl } from '../../utilities/apiUrl';
import { useOutletContext } from 'react-router-dom';
import SmartphoneIcon from '@mui/icons-material/Smartphone';
import MailIcon from '@mui/icons-material/Mail';
import { capitalizeWords } from '../../utilities/capitalizeWords';
import { formatISOToPHT } from '../../utilities/date';
const style = {
  mr: 3,
  fontWeight: 600,
};

const boxStyle = {
  mx: 0,
  my: 1,
  px: 3,
  py: 2,
};

const boxInfoStyle = {
  bgcolor: '#3A4152',
  width: 1,
  p: 1,
  px: 2,
  borderRadius: 1,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
};

const detailsStyle = {
  textTransform: 'capitalize',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: 1,
  display: 'inline-block',
  cursor: 'default',
  minHeight: 24,
};

const titleStyle = {
  color: '#84d8c5',
  fontWeight: 600,
  ml: 2,
};

export const UserInfo = (props) => {
  const [changePassModalOpen, setChangePassModalOpen] = useState(false);
  const [twoFAModalOpen, setTwoFAModalOpen] = useState(false);
  const [empId] = useOutletContext();
  const [emp, setEmp] = useState({});
  const [selectedEmp, setSelectedEmp] = useState('');

  // const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");

  // RETRIEVE USER INFO
  useEffect(() => {
    fetch(apiUrl('/employee/' + empId), {
      method: 'GET',
      credentials: 'include',
    })
      .then((response) => response.json())
      .then((data) => {
        setEmp(data.data);
        // setUsername(data.data.username);
        // setPassword(data.data.password);
      });
  }, [empId]);

  // EDIT MODAL HANDLER
  const handleChangePassModalOpen = () => {
    setChangePassModalOpen(true);
    setSelectedEmp(emp._id);
  };

  // 2FA MODAL HANDLER
  const handle2FAModalOpen = () => {
    setTwoFAModalOpen(true);
    setSelectedEmp(emp._id);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Box sx={boxStyle}>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Box sx={boxInfoStyle}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 2 }}>
                Nickname:
              </Typography>

              <Tooltip title={capitalizeWords(props.empData.nickname)} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {props.empData.nickname}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box sx={boxInfoStyle}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 2 }}>
                Birthday:
              </Typography>

              <Tooltip title={formatISOToPHT(props.empData?.dateofbirth)} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {formatISOToPHT(props.empData?.dateofbirth)}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box sx={boxInfoStyle}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 2 }}>
                Sex:
              </Typography>
              <Tooltip title={capitalizeWords(props.empData.sex)} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {props.empData.sex}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={6}>
            <Box sx={boxInfoStyle}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mr: 2 }}>
                Citizenship:
              </Typography>
              <Tooltip title={capitalizeWords(props.empData.citizenship)} arrow>
                <Typography
                  variant="body1"
                  sx={{
                    ...detailsStyle,
                  }}
                >
                  {props.empData.citizenship}
                </Typography>
              </Tooltip>
            </Box>
          </Grid>

          <Grid item xs={4}>
            <Box sx={boxInfoStyle}>
              <SmartphoneIcon sx={{ fontSize: 22, mr: 2 }} />
              <Typography variant="body1">{props.empData.cellphone}</Typography>
            </Box>
          </Grid>

          <Grid item xs={8}>
            <Box sx={boxInfoStyle}>
              <MailIcon sx={{ fontSize: 22, mr: 2 }} />
              <Typography variant="body1">{props.empData.email}</Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>

      <OutlinedButton
        style={{ mt: 'auto', mx: 3, my: 2, px: 2.6, py: 1 }}
        variant="outlined"
        onClick={handleChangePassModalOpen}
        btnTitle="Change Password"
      />

      <OutlinedButton
        style={{ mt: 'auto', mx: 3, my: 2, px: 2.6, py: 1 }}
        variant="outlined"
        onClick={handle2FAModalOpen}
        btnTitle="Two-Factor Authentication"
      />

      <TwoFaModal
        open={twoFAModalOpen}
        onClose={() => setTwoFAModalOpen(false)}
        emp={emp}
        setEmp={setEmp}
      />
      <ChangePassModal
        open={changePassModalOpen}
        onClose={() => setChangePassModalOpen(false)}
        emp={emp}
      />
    </Box>
  );
};
